import {Button, Modal, Select, Spin, Typography, Divider, message} from "antd";
import {copyToClipboard} from "../utility/clipboard";
import React, {useEffect, useMemo, useState} from "react";
import {PaperClipOutlined, ReloadOutlined} from "@ant-design/icons";

import {
    getAllAttributeValues,
} from "apiService/RESTApi";

export default function AttributeVariablePicker({open, onCancel, customerId}) {
    const {Title, Text} = Typography;

    const replacementVars = [
        { label: "First Name", value: "{{User.UserAttributes.FirstName}}" },
        { label: "Last Name", value: "{{User.UserAttributes.LastName}}" },
        {label: "Magic Link", value: "{{magic_link}}"},
        {label: "Magic Code", value: "{{magic_code}}"},
        {label: "Unsubscribe Link", value: "{{unsubscribe}}"},
    ];

    const [attributes, setAttributes] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadAttributes();
    }, []);

    const handleAttributeSelector = (attributeName) => {
        if (attributeName === undefined) {
           return;
        }
        const variable = `{{User.UserAttributes.${attributeName}}}`;
        copyToClipboard(variable);
    };

    const attrOptions = useMemo(() =>
            attributes.map((a) => ({
                value: a.attributeName,
                label: a.attributeName || a.attributeName,
            })),
        [attributes]
    );

    const loadAttributes = async () => {
        setLoading(true);
        try {
            let res = await getAllAttributeValues(customerId);

            let dataArray = [];
            res?.response?.data?.forEach((el) => {
                dataArray.push({
                    attributeId: el?.dataClassAttributeId,
                    attributeName: el?.name,
                });
            });
            setAttributes(dataArray);
        } catch (e) {
            message.error("Could not load contact attributes.");
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                open={open}
                onCancel={onCancel}
                onRequestClose={onCancel}
                cancelText={""}
                cancelButtonProps={{ style: { display: 'none' } }}
                contentLabel="Variable Replacement"
                className="modal"
                overlayClassName="overlay"
                shouldCloseOnOverlayClick={false}
                closeIcon={true}
                okText="Done"
                onOk={onCancel}
            >
                <div className="assets-header">
                    <h2>Variable Replacement</h2>
                </div>
                <ul className="assets-list">
                    {replacementVars.map((item) => (
                        <li className="asset-item" key={item.label}>
                            <span className="asset-url"> {item.label}</span>
                            <Button className="copy-button" type="text" icon={<PaperClipOutlined/>}
                                    onClick={() => copyToClipboard(item.value)}
                            />
                        </li>
                    ))}
                </ul>

                <Divider style={{margin: "16px 0"}}/>

                <div className="contact-attributes">
                    <div style={{display: "flex", alignItems: "center", gap: 8, marginBottom: 8}}>
                        <Title level={5} style={{margin: 0}}>Contact Attributes</Title>
                        <Button size="small" icon={<ReloadOutlined/>} onClick={loadAttributes} disabled={loading}/>
                        <Text type="secondary">{loading ? "Loading…" : `${attributes.length} available`}</Text>
                    </div>

                    {loading ? (
                        <Spin/>
                    ) : (
                        <Select
                            showSearch
                            placeholder="Search and select an attribute to copy"
                            options={attrOptions}
                            style={{width: "100%"}}
                            onSelect={handleAttributeSelector}
                            filterOption={(input, option) =>
                                (option?.label?.toLowerCase?.() || "").includes(input.toLowerCase()) ||
                                (option?.value?.toLowerCase?.() || "").includes(input.toLowerCase())
                            }
                        />
                    )}
                    <Text type="secondary" style={{display: "block", marginTop: 8}}>
                        Selecting an item copies attribute name to your clipboard.
                    </Text>
                </div>
            </Modal>
        </>
    );
}